export default __webpack_public_path__ + "static/media/BJ.73026b4e.svg";